/** Theme preference keys, kept in their own module so non-theme code (e.g. the
 * auth context) can reference them without importing MUI through
 * `themes/index.tsx`. */

export const MODE_STORAGE_KEY = "socialpro-theme-mode";
/** The value is already persisted in users' browsers — renaming it resets
 * everyone's saved palette, so it stays as written. */
export const PRIMARY_PALETTE_STORAGE_KEY = "socialpro-theme-accent";

export const COLOR_SCHEME_STORAGE_KEY = "mui-color-scheme";

/** MUI writes the resolved colour scheme under `${colorSchemeStorageKey}-light`
 * / `-dark`. That suffix is still MUI's to change; `storageKeys.test.tsx` drives
 * the real provider and fails if what it writes stops matching this list. */
const MUI_COLOR_SCHEME_KEYS = [
  `${COLOR_SCHEME_STORAGE_KEY}-light`,
  `${COLOR_SCHEME_STORAGE_KEY}-dark`
];

/** Keys that survive sign-out: display preferences belong to the browser, not
 * the session, so clearing app state must not reset them. */
export const THEME_STORAGE_KEYS: readonly string[] = [
  MODE_STORAGE_KEY,
  PRIMARY_PALETTE_STORAGE_KEY,
  ...MUI_COLOR_SCHEME_KEYS
];
